<template>
  <v-col cols="12" xl="6" md="6" id="q" class="text-center">
    <!-- <v-icon class="icon">mdi-format-quote-open</v-icon> -->
    <v-icon class="icon mb-4">mdi-format-quote-open-outline</v-icon>
    <p class="quote mb-10">{{ quote }}</p>
    <p class="quoted mb-1">{{ quoted }}</p>
    <p class="q-info allcaps">{{ info }}</p>
  </v-col>
</template>

<script>
export default {
  name: 'Quote',
  data() {
    return {
      title: 'quote',
      quote: '“Tudo tem sido grande novidade para mim, não conhecia suas aplicações gerais e seus benefícios , só tinha um leve conhecimento sobre epilepsias graves. Foi tudo muito bom! Desde a história, base farmacológica, aplicações até resultados”',
      quoted: 'Dra Fatima Castro Sobral',
      info: 'Reumatologista'
    }
  },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

#q {
  .icon {
    font-size: 6em;
    color: $primary;
    z-index: 2;
    // &:nth-child(2) {
    //   z-index: 1;
    //   color: #191919;
    //   opacity: .2;
    //   margin-left: -60px;
    //   margin-bottom: -10px;
    // }
  }
  .quote {
    font-style: italic;
    font-size: 1rem;
  }
  .quoted {
    font-size: 1.1rem;
    font-weight: bold;
  }
  .q-info {
    font-size: .7rem;
  }
}
</style>